<template>
    <div class="product">
        <!-- <app-header></app-header> -->
        <header>
          <a href="#" @click.stop="back" class="back" style="z-index: 999;"></a>
          <a href="#" v-if="this.$store.getters['SDK/getStatus']" style="z-index: 999;" @click.stop="toggleMode" class="toggle-mode-compressed"></a>
        </header>
        <div class='modiface-area'>
            <Modiface></Modiface>
        </div>
    </div>
</template>
<script>
import Product from '@/components/mixins/Product'
import Modiface from '@/components/ui/Modiface'
export default {
  data () {
    return {
    }
  },
  mixins: [Product],
  components: {
    Modiface
  },
  mounted () {
    if (!this.$store.getter['SDK/getStatus']) this.$router.push({ path: `/products/${this.$props.eanupc}` })
  }
}
</script>
<style lang="scss">
.toggle-mode-compressed {
  $element-radius: 70px;
  background-image: url('../../assets/arrow-left.png');
  height: 100px;
  border-radius: 50%;
  background-repeat: no-repeat;
  background-position: 2px 10px;
  width: 100px;
  position: fixed;
  bottom: 25%;
  transform: rotate(90deg);
  left: 50%;
  // for centering
  margin-left: -$element-radius/2;
  border-radius: 50%;
  width: $element-radius;
  height: $element-radius;
  display: inline-block;
  background-color: #fff;
  z-index: 9999;
}
</style>
